import Timer from "./Timer";
class Interval extends Timer {
  constructor(callback, timeout) {
    super(callback, timeout, true);
  }
}
export default Interval;
